import React from "react";
import "./Layout.css"; // Import your global styling

const Layout = ({ children }: { children: any }) => {
	return <div className="app-container">{children}</div>;
};

export default Layout;
